import { fetchAuthorizedJsonApi, fetchJsonApi } from './abstract';
import { getApiLanguage } from './language';
/**
 * This fetches a survey that is chosen by the backend as a "default" survey.
 * The result contains only the survey object without voting information
 */
export function fetchSurvey(apiUrl) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        skipHumanVerification: undefined,
        method: 'GET',
        endpoint: 'v1/surveys',
        query: { lang: getApiLanguage() },
        expectedStatus: 200,
        description: 'Fetching survey',
    });
}
/**
 * If survey with requested id or alias cannot be found
 * this will respond with an empty object. Fetches survey object with current voting state
 */
export function fetchSurveyState(apiUrl, token, surveyId) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        token: token,
        method: 'GET',
        endpoint: "v1/surveys/".concat(surveyId),
        query: { lang: getApiLanguage() },
        expectedStatus: 200,
        description: 'Fetching survey state',
    });
}
/**
 * Used to perform a voting action.
 * Result contains the survey object, new voting state and possibly a purchase object as a reward for voting.
 */
export function vote(apiUrl, token, surveyId, value) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        method: 'PUT',
        endpoint: "v1/surveys/".concat(surveyId),
        query: { a: 'v', lang: getApiLanguage() },
        body: { vote: value },
        expectedStatus: 200,
        description: 'Voting in survey',
    });
}
